/**
 * Persist maxAge and default query gcTime must align (see TanStack persistQueryClient docs)
 * or garbage collection can discard restored cache earlier than maxAge.
 */
export const QUERY_PERSIST_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 365;
